import React, { useEffect, useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "./components/Auth/Login";
import Dashboard from "./components/Admin/Dashboard";
import { AuthProvider, AuthContext } from "./context/AuthContext";

// Import Bootstrap, FontAwesome, and Select2 from node_modules
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "select2/dist/css/select2.min.css";
import "select2/dist/js/select2.min";
import "@fortawesome/fontawesome-free/css/all.min.css";

function App() {
  return (
    <AuthProvider>
      <Router>
        <AssetLoader /> {/* Dynamically loads SB Admin 2 and other assets */}
        <Routes>
          {/* Website Routes */}
          
          
          {/* Admin Routes */}
          <Route path="/admin/system-login" element={<AuthRedirect />} />
          <Route path="/admin/dashboard/*" element={<PrivateRoute component={Dashboard} />} />

          <Route path="*" element={<Navigate to="/admin/system-login" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

// 🔹 Dynamically Load SB Admin 2 CSS & JS
const AssetLoader = () => {
  const location = useLocation();

  useEffect(() => {
    const isAdmin = location.pathname.startsWith("/admin");
    const assetPath = process.env.PUBLIC_URL; // Get correct public URL

    if (isAdmin) {
      loadCSS(`${assetPath}/css/sb-admin-2.min.css`); // SB Admin 2 CSS
      loadJS(`${assetPath}/js/sb-admin-2.min.js`); // SB Admin 2 JS
    }

    return () => removeLoadedAssets();
  }, [location.pathname]);

  return null;
};

// Helper functions to load CSS & JS dynamically
const loadCSS = (href) => {
  if (!document.querySelector(`link[href="${href}"]`)) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
  }
};

const loadJS = (src) => {
  if (!document.querySelector(`script[src="${src}"]`)) {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    document.body.appendChild(script);
  }
};

const removeLoadedAssets = () => {
  document.querySelectorAll("link[href*='sb-admin-2']").forEach((link) => link.remove());
  document.querySelectorAll("script[src*='sb-admin-2']").forEach((script) => script.remove());
};

// 🔹 Authentication Redirects
const AuthRedirect = () => {
  const { currentUser } = useContext(AuthContext);
  return currentUser ? <Navigate to="/admin/dashboard" /> : <Login />;
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { currentUser } = useContext(AuthContext);
  return currentUser ? <Component {...rest} /> : <Navigate to="/admin/system-login" />;
};

export default App;
